import { render, staticRenderFns } from "./CAxAFFxPhysiolSymptomsPage.vue?vue&type=template&id=4d22698f"
import script from "./CAxAFFxPhysiolSymptomsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFFxPhysiolSymptomsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFFxPhysiolSymptomsPage.vue?vue&type=style&index=0&id=4d22698f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports